/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentReminders from './AppointmentReminders/index'
import React from 'react'
import Relative from './Relative/index'
import SendNextAppointmentReminder from './SendNextAppointmentReminder/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/Content/Related/Content"
  
}) {
let relativesValueData = fromData.useDataValue({ viewPath,
context: 'relatives',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.List"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(relativesValueData) && relativesValueData.map((item, index, list) => 
<ListItem
        key={`${item?.cma_id}`}
        context="relative"
        item={item}
        index={index}
        list={list}
        hasItemKey={true}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Relative(${`${item?.cma_id}`})`}
      >
<Relative
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Relative(${`${item?.cma_id}`})`}
/>
</ListItem>
)}
</div>
<AppointmentReminders
  viewPath={`${viewPath}/AppointmentReminders`}
/>
<SendNextAppointmentReminder
  viewPath={`${viewPath}/SendNextAppointmentReminder`}
/>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }